<template>
  <IconWrapper :dense="dense">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75009 12.15L4.12509 9.52499C3.83259 9.23249 3.36759 9.23249 3.07509 9.52499C2.78259 9.81749 2.78259 10.2825 3.07509 10.575L6.21759 13.7175C6.51009 14.01 6.98259 14.01 7.27509 13.7175L15.2251 5.77499C15.5176 5.48249 15.5176 5.01749 15.2251 4.72499C14.9326 4.43249 14.4676 4.43249 14.1751 4.72499L6.75009 12.15Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  props: {
    dense: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg path {
  fill: var(--r-success-1);
}
</style>
